module.exports = __webpack_public_path__ + "static/img/3-g.5154d05c.png";